var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('iframe',{class:_vm.$style.iframe,attrs:{"src":_vm.embedUrl,"width":"100%","frameborder":"0","scrolling":"no","allowtransparency":"true"}})])}
var staticRenderFns = []

export { render, staticRenderFns }